import React, { useMemo } from 'react';
import { Icon, ScreenContainer, ContentFrame, LayoutContent, Typography, useTheme, } from '@pinwheel/origami';
import { useOpts } from '../context';
import './Intro.scss';
import ModalHeader from '../components/ModalHeader';
import getPlatformTypeName from '../consts/platform-types';
import { useGetLocalizedString } from '../hooks/useGetLocalizedString';
var Intro = function () {
    var resolveColor = useTheme().resolveColor;
    var getLocalizedString = useGetLocalizedString();
    var platformType = useOpts().linkTokenPayload.platformType;
    var localizedPlatformType = getLocalizedString(getPlatformTypeName(platformType));
    var aboutText = useMemo(function () { return getLocalizedString('PINWHEEL_LETS_YOU', [localizedPlatformType]); }, [localizedPlatformType, getLocalizedString]);
    var securityText = useMemo(function () { return getLocalizedString('ACCOUNT_TO_AN_APP', [localizedPlatformType]); }, [localizedPlatformType, getLocalizedString]);
    return (React.createElement(ScreenContainer, { "data-testid": "info" },
        React.createElement(ModalHeader, null),
        React.createElement(ContentFrame, null,
            React.createElement(LayoutContent, null,
                React.createElement("div", { className: "introLogo", style: {
                        backgroundColor: resolveColor({
                            type: 'theme',
                            colorLegacy: 'Neutral/0',
                            colorNext: 'background/alt',
                        }),
                    } },
                    React.createElement(Icon, { icon: "pinwheelLogo", size: 25, color: {
                            type: 'pinwheel',
                        } })),
                React.createElement(Typography, { variant: "header", as: "h2", sx: { marginBottom: '16px' } }, getLocalizedString('ABOUT_PINWHEEL')),
                React.createElement(Typography, { variant: "body", as: "p", "data-testid": "aboutText" }, aboutText),
                React.createElement(Typography, { variant: "header", as: "h2", sx: { margin: '16px 0' } }, getLocalizedString('HOW_WE_PROTECT')),
                React.createElement(Typography, { variant: "body", as: "p", "data-testid": "securityText" }, securityText)))));
};
export default Intro;
